export const UPDATE_CROPPER_VALUES = 'update_cropper_values'
export const TOGGLE_CROPPER_RATIO_LOCK = 'toggle_cropper_ratio_lock'
export const SET_CROPPER_ACTIVE = 'set_cropper_active'
export const SET_ACTIVE_PRESET_BY_ID = 'set_active_preset_by_id'
export const SET_CROPPER_CHANGED_STATUS = 'set_cropper_changed_status'
export const SET_CROPPER_MODAL = 'set_cropper_modal'
export const SET_CROPPER_REDIRECT = 'set_cropper_redirect'
